import React from 'react';
import classNames from 'classnames';

type StatTileVariant = 'blue' | 'orange' | 'purple';

type StatTileProps = {
  icon: React.ReactNode;
  label: string;
  count: number;
  variant: StatTileVariant;
  className?: string;
};

function StatTile({ icon, label, count, variant, className }: StatTileProps) {
  return (
    <div className={classNames('work-status-tile', `work-status-tile--${variant}`, className)}>
      <span className="work-status-tile__icon">{icon}</span>
      <div>
        <div className="work-status-tile__label">{label}</div>
        <div className="work-status-tile__count">{count}</div>
      </div>
    </div>
  );
}

export default StatTile;
